export enum OWAS_QUERY_KEYS {
	GET_OWAS = 'get-owas',
	GET_RESULT = 'get-owas-result'
}
